import { GridRowId } from "@mui/x-data-grid-premium";
import { createSlice } from "@reduxjs/toolkit";
import VwServisprotokol1DTO from "src/models/GenelTanimlar/VwServisprotokol1DTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";

export class IHesapPlanCache {
    hesapKod: string;
    detayHesapMask: number;
    cariGirisAktif: string;

    constructor(hesapKod, detayHesapMask, cariGirisAktif) {
        this.hesapKod = hesapKod;
        this.detayHesapMask = detayHesapMask;
        this.cariGirisAktif = cariGirisAktif;
    }
}

interface IHesapPlanState {
    hesapPlanTanimDialogOpen: boolean;
    detayMaskDict: Array<IHesapPlanCache>;
    expandedRows: Record<GridRowId, boolean>;
}

const HesapPlanTanimSlice = createSlice<IHesapPlanState, MapReducerPayloads<IHesapPlanState, {
    setHesapPlanTanimDialogOpen: boolean;
    setDetayMaskDict: Array<IHesapPlanCache>;
    setExpandedRows: Record<GridRowId, boolean>;
}>>({
    name: 'HesapPlanTanimState',
    initialState: {
        hesapPlanTanimDialogOpen: false,
        detayMaskDict: new Array<IHesapPlanCache>(),
        expandedRows: {},
    },
    reducers: {
        setHesapPlanTanimDialogOpen: (state, action) => {
            state.hesapPlanTanimDialogOpen = action.payload;
        },
        setDetayMaskDict: (state, action) => {
            state.detayMaskDict = action.payload;
        },
        setExpandedRows: (state, action) => {
            state.expandedRows = action.payload
        },
    }
})
export default HesapPlanTanimSlice;